<div class="padding">
    <div class="card card-1 padding table-wrapper" *ngIf="!is_loading">
        <app-fb-forms-table [storeObj]="RaceTypeVehicleClass"
                            [edit_allowed]="true"
                            [require_filter]="require_filter"
                            (row_click)="rowSelected($event)"
                            [storeExtObj]="ext_obj"
                            [stateKey]="'race_type_vehicle_class'"
                            [show_add]="false"
                            [show_add_in_view]="true"
                            [show_delete]="true"
                            (dataLoaded)="dataLoadedDone($event)"
                            [title]="'Vehicle Class'"
        >
        </app-fb-forms-table>
    </div>
</div>
